import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActiveAssetData } from '@/lib/services/websocket.service';

interface WSUserDataState {
  activeAssetData: Record<string, ActiveAssetData>; // key: coin symbol
  loading: boolean;
  error: string | null;
}

const initialState: WSUserDataState = {
  activeAssetData: {},
  loading: false,
  error: null,
};

export const wsUserDataSlice = createSlice({
  name: 'wsUserData',
  initialState,
  reducers: {
    setActiveAssetData: (state, action: PayloadAction<ActiveAssetData>) => {
      const { coin } = action.payload;
      state.activeAssetData[coin] = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearActiveAssetData: (state) => {
      state.activeAssetData = {};
      state.loading = false;
      state.error = null;
    },
    removeActiveAssetData: (state, action: PayloadAction<string>) => {
      const coin = action.payload;
      delete state.activeAssetData[coin];
    },
  },
});

export const { 
  setActiveAssetData, 
  setLoading, 
  setError, 
  clearActiveAssetData, 
  removeActiveAssetData 
} = wsUserDataSlice.actions;

// Selectors
export const selectActiveAssetData = (state: { wsUserData: WSUserDataState }) => 
  state.wsUserData.activeAssetData;

export const selectActiveAssetDataForCoin = (coin: string) => (state: { wsUserData: WSUserDataState }) => {
  return state.wsUserData.activeAssetData[coin] || null;
};

export const selectUserLeverageForCoin = (coin: string) => (state: { wsUserData: WSUserDataState }) => {
  const assetData = state.wsUserData.activeAssetData[coin];
  return assetData?.leverage?.value || null;
};

export const selectActiveAssetDataLoading = (state: { wsUserData: WSUserDataState }) => 
  state.wsUserData.loading;

export const selectActiveAssetDataError = (state: { wsUserData: WSUserDataState }) => 
  state.wsUserData.error;

export default wsUserDataSlice.reducer;